export const EMPLOYEE_GENDER_OPTIONS = [
  { value: 1, text: "Female" },
  { value: 0, text: "Male" },
];

export const EMPLOYEE_MARITAL_STATUS_OPTIONS = [
  { value: "MARRIED", text: "Married" },
  { value: "SINGLE", text: "Single" },
];

export const EMPLOYEE_BOOLEAN_OPTIONS = [
  { value: 1, text: "Yes" },
  { value: 0, text: "No" },
];
